module.exports = __webpack_public_path__ + "static/img/5_3.0792abb1.jpg";